import type { FC } from 'react';
import React from 'react';

import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { Text, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type PrincipalDetailsWarningMessageProps = {
	warningMessage: React.ReactNode;
};

export const PrincipalDetailsWarningMessage: FC<PrincipalDetailsWarningMessageProps> = ({
	warningMessage,
}) => {
	return (
		<Inline alignBlock="center">
			<StatusWarningIcon
				label=""
				color={token('color.icon.warning')}
				spacing="spacious"
				size="small"
			/>
			<Text size="small">{warningMessage}</Text>
		</Inline>
	);
};
